import { useQuery } from '@tanstack/react-query';
import {
  TransferWithEvidenceService,
  GetTransferRequestListEntity,
} from 'services/openapi';
import { BidvTransferWithEvidenceQueryKeys } from './constants';
import { isEmpty } from 'lodash';
import type { TransferRequestStatus } from './useGetTransferRequestListQuery';

export type GetOwnTransferRequestListVariables = {
  fromTime?: string;
  toTime?: string;
  status?: TransferRequestStatus;
  page?: string;
  size?: string;
  companyId?: string;
};

export const useGetOwnTransferRequestListQuery = (
  variables: GetOwnTransferRequestListVariables,
  enabled = true,
) => {
  const queryKey = [
    BidvTransferWithEvidenceQueryKeys.GET_OWN_TRANSFER_REQUEST_LIST,
    variables,
  ];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetTransferRequestListEntity, Error>({
    queryKey,
    queryFn: () =>
      TransferWithEvidenceService.transferWithEvidenceControllerGetOwnList(
        variables.fromTime,
        variables.toTime,
        variables.status,
        variables.page,
        variables.size,
        variables.companyId,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    enabled: enabled && !isEmpty(variables), // Chỉ chạy query khi variables đã có giá trị
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
